<template>
	<button
		type="button"
		aria-label="Open Bag"
		@click="openBagPanel"
		class="relative w-6 h-6 md:w-5 md:h-5 flex items-center justify-center"
	>
		<svg-vue v-if="!isCartEmpty" icon="dot-md" class="overflow-visible w-1.5 h-1.5 z-10 absolute left-[9px] top-3" />
		<svg-vue
			icon="shopping-bag"
			class="w-6 h-6 md:w-5 md:h-5 overflow-visible absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
		/>
	</button>
	<TransitionRoot unmount :show="bagPanelOpen">
		<TransitionChild
			as="template"
			enter="transition-opacity ease-linear duration-300"
			enter-from="opacity-0"
			enter-to="opacity-100"
			leave="transition-opacity ease-linear duration-300"
			leave-from="opacity-100"
			leave-to="opacity-0"
		>
			<div class="bg-black/50 fixed inset-0 z-20" @click="handleClickoutside"></div>
		</TransitionChild>
		<TransitionChild
			as="template"
			enter="transition ease-in-out duration-300 transform"
			enter-from="translate-x-full"
			enter-to="translate-x-0"
			leave="transition ease-in-out duration-300 transform"
			leave-from="translate-x-0"
			leave-to="translate-x-full"
		>
			<aside class="bg-white fixed top-0 right-0 w-full md:w-[480px] h-full z-20">
				<div class="w-full flex flex-col justify-between h-full relative">
					<bag-free-shipping-reward />
					<ul class="!p-0 !px-4 !m-0 !pb-4 flex flex-col gap-4 overflow-y-scroll no-scrollbar mb-auto">
						<bag-palette-credit-reward />
						<bag-item-rewards />
						<li class="border-b seint-border-secondary"></li>
						<bag-items :loyalty-removal-endpoint="loyaltyRemovalEndpoint" />
					</ul>
					<bag-footer :shop-compacts-route="shopCompactsRoute" :checkout-route="checkoutRoute" />
				</div>
			</aside>
		</TransitionChild>
	</TransitionRoot>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { TransitionRoot, TransitionChild } from '@headlessui/vue'
import { storeToRefs } from 'pinia'

import { useAppStore, useCartStore, useRewardsStore } from '@stores'

const props = defineProps({
	disablePaletteCredit: {
		type: Boolean,
		default: false,
	},
	saleInformation: {
		type: Array,
		required: true,
	},
	loyaltyRemovalEndpoint: {
		type: String,
		required: true,
	},
	shopCompactsRoute: {
		type: String,
		required: true,
	},
	checkoutRoute: {
		type: String,
		required: true,
	},
})

const appStore = useAppStore()
const { bagPanelOpen } = storeToRefs(appStore)
const { openBagPanel, closeBagPanel } = appStore
const cartStore = useCartStore()
const { isCartEmpty } = storeToRefs(cartStore)
const rewardStore = useRewardsStore()

onMounted(() => document.addEventListener('keydown', handleKeydown))
onUnmounted(() => document.removeEventListener('keydown', handleKeydown))

const handleKeydown = (e) => {
	if (e.key === 'Escape' && bagPanelOpen.value) {
		closeBagPanel()
	}
}
const handleClickoutside = () => {
	if (bagPanelOpen.value) {
		closeBagPanel()
	}
}
</script>
